import React, { useState } from "react";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import { EmailComposer } from "./useEmailComposer";

const ComposerContextPanel = ({ composer, originalOpen, onToggleOriginal }: {
    composer: EmailComposer;
    originalOpen: boolean;
    onToggleOriginal: () => void;
}) => {
    const { t } = useOfficeTranslation();
    const [expanded, setExpanded] = useState(false);
    const { draft, accounts, tenants, reply, sending } = composer;
    const tenant = tenants.find(value => value.id === draft.tenantId);
    const account = accounts.find(value => value.id === draft.accountId);
    return <aside className={`composer-context ${expanded ? "is-expanded" : ""}`} aria-label={t("email.composer.context")}>
        <h3 className="composer-context-heading">{t("email.composer.context")}</h3>
        <button type="button" className="composer-context-toggle" aria-expanded={expanded} aria-controls="composer-context-fields" onClick={() => setExpanded(value => !value)}>
            <span><strong>{tenant?.name ?? t("email.composer.chooseTenant")}</strong><small>{account?.legal_name ?? t("email.composer.noAccount")}</small></span>
            <i className={`mdi mdi-chevron-${expanded ? "up" : "down"}`} aria-hidden="true" />
        </button>
        <div id="composer-context-fields" className="composer-context-fields">
            <div className="mb-3">
                <label htmlFor="composer-tenant" className="form-label">{t("common.tenant")}</label>
                {tenants.length === 1 && draft.tenantId === tenants[0].id ? <p className="composer-context-value">{tenant?.name}</p> :
                    <select id="composer-tenant" className="form-select" disabled={sending} value={draft.tenantId ?? ""} onChange={event => composer.patch({ tenantId: event.target.value || null })}>
                        <option value="">{t("email.composer.chooseTenant")}</option>
                        {draft.tenantId && !tenant && <option value={draft.tenantId}>{t("email.composer.unavailableTenant")}</option>}
                        {tenants.map(value => <option key={value.id} value={value.id}>{value.name}</option>)}
                    </select>}
            </div>
            <div className="mb-3">
                <label htmlFor="composer-account" className="form-label">{t("common.account")} <small className="text-muted">{t("email.composer.optional")}</small></label>
                <select id="composer-account" className="form-select" disabled={sending} value={draft.accountId ?? ""} onChange={event => composer.selectAccount(event.target.value || null)}>
                    <option value="">{t("email.composer.noAccount")}</option>
                    {draft.accountId && !account && <option value={draft.accountId}>{t("email.composer.unavailableAccount")}</option>}
                    {accounts.map(value => <option key={value.id} value={value.id}>{value.legal_name}</option>)}
                </select>
                <small className="text-muted">{t("email.composer.accountHelp")}</small>
            </div>
            {draft.reference && <p className="composer-reference"><i className="mdi mdi-link-variant me-1" aria-hidden="true" />
                {draft.reference.startsWith("invoice_") ? t("email.composer.invoiceLinked") : draft.reference}
            </p>}
            {reply && <div className="composer-original-summary">
                <span className="text-muted">{t("email.composer.replyingTo")}</span>
                <strong>{reply.sender_name || reply.sender}</strong>
                <p>{reply.subject}</p>
                <button type="button" className="btn btn-outline-secondary" aria-expanded={originalOpen} aria-controls="composer-original" onClick={onToggleOriginal}>
                    {originalOpen ? t("email.composer.hideOriginal") : t("email.composer.showOriginal")}
                </button>
            </div>}
        </div>
    </aside>;
};

export default ComposerContextPanel;
